module.exports = "<label *ngIf=\"showCaption\" [ngClass]=\"position === 1 ? '' : _captionWidth\">{{\r\n  caption\r\n}}</label>\r\n<div [ngClass]=\"position === 1 ? '' : _fieldWidth\">\r\n  <textarea\r\n    [disabled]=\"disabled\"\r\n    style=\"position: relative;\"\r\n    [rows]=\"rows\"\r\n    [placeholder]=\"placeholder\"\r\n    type=\"text\"\r\n    class=\"form-control \"\r\n    [(ngModel)]=\"value\"\r\n    [maxlength]=\"maxlength\"\r\n    [minlength]=\"minlength\"\r\n    (blur)=\"onBlur()\"\r\n    id=\"fieldName\"\r\n  >\r\n  </textarea>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixstextarea/ixstextarea.component.html
// module id = 1211
// module chunks = 320